import { initFederation } from '@angular-architects/native-federation';

import { environment } from './environments/environment';

const federationInitTimeoutMs = 10_000;

const federationManifest = Object.fromEntries(
  Object.entries(environment.remotes).map(([remoteId, config]) => [remoteId, config.remoteEntry]),
);

function initializeFederation(): Promise<void> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  return Promise.race([
    initFederation(federationManifest),
    new Promise<never>((_, reject) => {
      timeoutId = setTimeout(
        () => reject(new Error('Native Federation initialization timed out.')),
        federationInitTimeoutMs,
      );
    }),
  ])
    .then(() => undefined)
    .finally(() => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    });
}

void initializeFederation()
  .catch((error: unknown) => {
    // Federation is optional for the shell. In particular, a physical tablet
    // may use the ERP/API proxy before the local Developer MFE is running.
    console.warn('Developer federation is unavailable; continuing with shell fallbacks.', error);
  })
  .then(() => import('./bootstrap').then(({ bootstrapErpApp }) => bootstrapErpApp()))
  .catch((error: unknown) =>
    import('./bootstrap')
      .then(({ bootstrapUnavailableApp }) => bootstrapUnavailableApp(error))
      .catch((fallbackError: unknown) => console.error(fallbackError)),
  );
